import { useState } from 'react';
import { Alert, Button, Card, Col, Form, InputGroup, Row } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import DatePicker from 'react-datepicker';
import { CiEdit, CiFilter, CiTrash } from 'react-icons/ci';
import { FaCheckCircle, FaRegEdit, FaTimesCircle } from 'react-icons/fa';
import { IoAddCircleOutline } from 'react-icons/io5';
import { TbListDetails } from 'react-icons/tb';
import "react-datepicker/dist/react-datepicker.css";
import { BiSearch } from 'react-icons/bi';
import { RiResetLeftFill } from 'react-icons/ri';
import Swal from 'sweetalert2';

const ProductTable = ({ updateOnActive, products, onEdit, onDelete, onDetail, modalAddDetail }) => {


  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);

  // const [startDate, setStartDate] = useState(null);
  // const [expiredDate, setExpiredDate] = useState(null);
  // const [searchQuery, setSearchQuery] = useState("");
  // const [filteredData, setFilteredData] = useState(products);

  // const handleSearchChange = (e) => {
  //   setSearchQuery(e.target.value);
  // };

  // const handleFiltersChange = () => {
  //   const filtered = products.filter(item => {
  //     const itemStartDate = item.release_date;
  //     const itemExpiredDate = item.expiredDate;

  //     // Apply filters only if they are set
  //     const withinStartDate = startDate ? itemStartDate >= startDate : true;
  //     const withinExpiredDate = expiredDate ? itemExpiredDate <= expiredDate : true;
  //     const matchesSearch = item.name.toLowerCase().includes(searchQuery.toLowerCase());

  //     return withinStartDate && withinExpiredDate && matchesSearch;
  //   });

  //   // Update filteredData to show filtered results or the full dataset when no filters are applied
  //   setFilteredData(filtered.length > 0 ? filtered : products);
  // };
  const [filteredProducts, setFilteredProducts] = useState(products);

  const [releaseStartDate, setReleaseStartDate] = useState(null);
  const [releaseEndDate, setReleaseEndDate] = useState(null);
  const [expiredStartDate, setExpiredStartDate] = useState(null);
  const [expiredEndDate, setExpiredEndDate] = useState(null);
  const [name, setName] = useState("");

  const handleFiltersChange = () => {
    const filtered = products.filter((product) => {
      const releaseDateMatch =
        (!releaseStartDate || product.release_date >= releaseStartDate) &&
        (!releaseEndDate || product.release_date <= releaseEndDate);
      const expiredDateMatch =
        (!expiredStartDate || product.expired_date >= expiredStartDate) &&
        (!expiredEndDate || product.expired_date <= expiredEndDate);
      const nameMatch = (product.name ?? '').toLowerCase().includes((name ?? '').toLowerCase());

      return releaseDateMatch && expiredDateMatch && nameMatch;
    });

    setFilteredProducts(filtered);
  };

  const handleDateRelaseStartChange = (date) => {
    if (date) {
      // Format the date to "YYYY-MM-DD"
      const formattedDate = date.toISOString().split("T")[0];
      setReleaseStartDate(formattedDate);
    } else {
      setReleaseStartDate("");
    }
  };

  const handleDateRelaseEndChange = (date) => {
    if (date) {
      // Format the date to "YYYY-MM-DD"
      const formattedDate = date.toISOString().split("T")[0];
      setReleaseEndDate(formattedDate);
    } else {
      setReleaseEndDate("");
    }
  };

  const handleDateExpStartChange = (date) => {
    if (date) {
      // Format the date to "YYYY-MM-DD"
      const formattedDate = date.toISOString().split("T")[0];
      setExpiredStartDate(formattedDate);
    } else {
      setExpiredStartDate("");
    }
  };

  const handleDateExpEndChange = (date) => {
    if (date) {
      // Format the date to "YYYY-MM-DD"
      const formattedDate = date.toISOString().split("T")[0];
      setExpiredEndDate(formattedDate);
    } else {
      setExpiredEndDate("");
    }
  };

  const resetFilters = () => {
    setReleaseStartDate(null);
    setReleaseEndDate(null);
    setExpiredStartDate(null);
    setExpiredEndDate(null);
    setName("");
    setFilteredProducts(products);
  };

  const handleToggleStatus = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to change status to ${row.active === 1 ? "Inactive" : "Active"}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const updatedStatus = row.active == 1 ? 0 : 1;
          updateOnActive(row.id, { id: row.id, active: updatedStatus })
          Swal.fire("Updated!", "Status has been updated.", "success");
          window.location.reload()
        } catch (error) {
          console.error("Failed to update status", error);
          Swal.fire("Error!", "Failed to update status.", "error");
        }
      }
    });
  };

  const columns = [
    {
      name: 'No.',  // Serial Number Column
      selector: (row, index) => index + 1,
      sortable: true,
      width: '60px',  // Optional: Adjusts the width
    },
    { name: 'Name', selector: row => row.name, sortable: true },
    { name: 'Alias Name', selector: row => row.alias_name, sortable: true },
    { name: 'Price', selector: row => `Rp ${row.starting_price}`, sortable: true },
    {
      name: 'Promo Price', selector: row => (
        row.promo_price ? `Rp ${row.promo_price}` : ''),
      sortable: true
    },
    { name: 'Release Date', selector: row => row.release_date, sortable: true },
    { name: 'Expired Date', selector: row => row.expired_date, sortable: true },
    { name: 'Age Type', selector: row => row.ageGroupProductString, sortable: true },
    { name: 'Code Promo', selector: row => row.promo_code, sortable: true, },
    { name: 'Name Promo', selector: row => row.promo_name, sortable: true },
    {
      name: 'Active',
      cell: row => (
        <span
          style={{ cursor: 'pointer', color: row.active === 1 ? 'green' : 'red' }}
          onClick={() => handleToggleStatus(row)}
        >
          {row.active === 1 ? <FaCheckCircle /> : <FaTimesCircle />} {row.active === 1 ? 'Active' : 'Inactive'}
        </span>
      ),
      sortable: true,
    },
    { name: 'Meta Title', selector: row => row.meta_title, sortable: true },
    {
      name: 'Image', selector: row => (
        <img
          src={row.image} // Replace with your image field
          // alt={row.name} // Add an alt attribute for accessibility
          style={{ width: '30px', height: '30px', objectFit: 'cover', borderRadius: '4px' }} // Styling
        />
      ),
      omit: true
    },
    {
      name: 'Actions',
      cell: row => (
        <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
          <Button variant="outline-warning" size="sm" onClick={() => onEdit(row)}>
            <CiEdit size={16} />
          </Button>
          <Button variant="outline-info" size="sm" onClick={() => modalAddDetail(row)}>
            <TbListDetails size={16} />
          </Button>
          <Button variant="outline-danger" size="sm" onClick={() => onDelete(row)}>
            <CiTrash size={16} />
          </Button>
        </div>
      ),
      // center: true, // Ensures alignment within DataTable
      // width: "150px", // Adjust width if needed
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "14px", // Adjust header font size
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        fontSize: "12px", // Adjust cell font size
        padding: "0px",
        margin: "0px"
      },
    },
    rows: {
      style: {
        minHeight: "35px", // Minimum row height
        maxHeight: "35px", // Maximum row height (optional)
      },
    },
  };


  return (
    <>
      {selectedRows.length > 0 && (
        <Button Tooltip={"test"} variant="outline-danger" className="me-1 mb-2">
          <CiTrash size={32} />
        </Button>
      )}

      <Card className="h-90 mb-2">
        <Card.Body>
          <Form>
            <Row className="g-1">
              {/* Release Date Range */}
              <Col xs={12} sm={6} md={1}>
                <Form.Group style={{ fontSize: 13 }}>
                  {/* <Form.Label>Release Date (From)</Form.Label> */}
                  <DatePicker
                    selected={releaseStartDate}
                    onChange={(date) => handleDateRelaseStartChange(date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="From release date"
                    customInput={
                      <input style={{ fontSize: "13px", padding: "6px", width: "100%" }} />
                    }
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={1}>
                <Form.Group style={{ fontSize: 13 }}>
                  {/* <Form.Label>Release Date (To)</Form.Label> */}
                  <DatePicker
                    selected={releaseEndDate}
                    onChange={(date) => handleDateRelaseEndChange(date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Release date to"
                    customInput={
                      <input style={{ fontSize: "13px", padding: "6px", width: "100%" }} />
                    }
                  />
                </Form.Group>
              </Col>

              {/* Expired Date Range */}
              <Col xs={12} sm={6} md={1}>
                <Form.Group style={{ fontSize: 13 }}>
                  {/* <Form.Label>Expired Date (From)</Form.Label> */}
                  <DatePicker
                    selected={expiredStartDate}
                    onChange={(date) => handleDateExpStartChange(date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="From expired date"
                    customInput={
                      <input style={{ fontSize: "13px", padding: "6px", width: "100%" }} />
                    }
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={1} style={{ fontSize: 13 }}>
                <Form.Group style={{ fontSize: 13 }}>
                  {/* <Form.Label>Expired Date (To)</Form.Label> */}
                  <DatePicker
                    selected={expiredEndDate}
                    onChange={(date) => handleDateExpEndChange(date)}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Expired date to"
                    customInput={
                      <input style={{ fontSize: "13px", padding: "6px", width: "100%" }} />
                    }
                  />
                </Form.Group>
              </Col>

              {/* Name Filter */}
              <Col xs={12} sm={6} md={1}>
                <Form.Group style={{ fontSize: 13 }}>
                  {/* <Form.Label>Name</Form.Label> */}
                  <Form.Control
                    type="text"
                    placeholder="Search name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    style={{ fontSize: 13 }}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={2}>
                <InputGroup style={{ fontSize: 13 }}>
                  <Button style={{ fontSize: 13 }} variant="outline-secondary" onClick={handleFiltersChange}>
                    <CiFilter />Filters
                  </Button>
                  <Button style={{ fontSize: 13 }} variant="outline-info" onClick={resetFilters}>
                    <RiResetLeftFill /> Reset
                  </Button>
                </InputGroup>
              </Col>
            </Row>
            <Row>
            </Row>
          </Form>
          <DataTable
            title="Products"
            columns={columns}
            data={filteredProducts.length > 0 ? filteredProducts : products}
            pagination
            responsive
            highlightOnHover
            customStyles={customStyles}
            defaultSortFieldId={1}
          />
        </Card.Body>
      </Card>
    </>
  )
};

export default ProductTable;